import { useQuery } from '@tanstack/react-query';
import { api, type MarketContext } from '../lib/api';
import { fmt } from '../lib/format';

function fngLabel(v: number): { text: string; color: string; action: string } {
  if (v <= 25) {
    return {
      text: 'Extreme Fear',
      color: 'var(--success)',
      action: 'Bot memperketat buffer (F&G ekstrem). Rekomendasi lebih selektif — bukan sinyal beli panik.',
    };
  }
  if (v <= 45) {
    return {
      text: 'Fear',
      color: 'var(--cin-emerald, #4ade80)',
      action: 'Sentimen hati-hati. Soft score tetap jalan normal; cek jarak strike ke spot.',
    };
  }
  if (v <= 55) {
    return {
      text: 'Neutral',
      color: 'var(--gl-text-muted)',
      action: 'Tidak ada penalti F&G khusus. Putuskan dari gate + skor.',
    };
  }
  if (v <= 75) {
    return {
      text: 'Greed',
      color: 'var(--warning)',
      action: 'Pasar optimis. Hati-hati chase APR tinggi di strike yang terlalu dekat.',
    };
  }
  return {
    text: 'Extreme Greed',
    color: 'var(--danger)',
    action: 'Bot memperketat buffer. Jangan anggap skor aman = aman total.',
  };
}

export function SentimenPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['context', 'BTCUSDT'],
    queryFn: () => api.get<MarketContext>('/api/data/context?symbol=BTCUSDT'),
    refetchInterval: 60_000,
  });

  const fg = Number(data?.fear_greed);
  const meta = Number.isFinite(fg) ? fngLabel(fg) : null;
  const fund = data?.funding_rate != null ? Number(data.funding_rate) : null;

  return (
    <div className="gl-page">
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 20, fontWeight: 600, color: 'var(--gl-text)' }}>Sentimen</div>
        <div style={{ fontSize: 12, color: 'var(--gl-text-muted)', marginTop: 4 }}>
          Fear &amp; Greed + funding — dipakai soft score (bukan gate fatal).
        </div>
      </div>

      {isLoading && <div className="gl-empty">Memuat…</div>}
      {error && <div className="settings-alert settings-alert--error">Gagal: {(error as Error).message}</div>}

      {data && meta && (
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(240px, 320px) 1fr', gap: 16 }}>
          <div className="g-card" style={{ textAlign: 'center', padding: 28 }}>
            <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.6, color: 'var(--gl-text-faint)' }}>
              Fear &amp; Greed Index
            </div>
            <div style={{ fontSize: 64, fontWeight: 800, color: meta.color, lineHeight: 1.1, margin: '12px 0' }}>
              {fg}
            </div>
            <div style={{ fontSize: 16, fontWeight: 600, color: meta.color }}>{meta.text}</div>
            <div style={{ fontSize: 11, color: 'var(--gl-text-faint)', marginTop: 8 }}>Skala 0–100 · Alternative.me</div>
            {/* simple bar */}
            <div style={{ marginTop: 20, height: 8, borderRadius: 99, background: '#222', overflow: 'hidden' }}>
              <div style={{ width: `${Math.min(100, Math.max(0, fg))}%`, height: '100%', background: meta.color, borderRadius: 99 }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: 'var(--gl-text-faint)', marginTop: 6 }}>
              <span>Fear</span>
              <span>Greed</span>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div className="g-card">
              <div className="gl-label">Arti untuk bot DCD</div>
              <p style={{ fontSize: 14, color: 'var(--gl-text)', lineHeight: 1.55, margin: 0 }}>{meta.action}</p>
            </div>
            <div className="g-card">
              <div className="gl-label">Funding rate (futures)</div>
              <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--gl-text)' }}>
                {fmt.percent(fund != null ? fund * 100 : null, 4)}
              </div>
              <p style={{ fontSize: 12, color: 'var(--gl-text-muted)', marginTop: 8, lineHeight: 1.5, marginBottom: 0 }}>
                Positif = long bayar short. Ekstrem (mis. |funding| besar) menambah bobot soft score — bukan hard reject.
              </p>
            </div>
            <div className="g-card" style={{ fontSize: 12, color: 'var(--gl-text-faint)' }}>
              Top trader long/short ratio (parameter #8 blueprint) belum di-wire — akan tampil di halaman ini nanti.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
